import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { copySteps } from '@/mocks/scale';

export default function CopyModel() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="0# → 1# → N#"
            title="从城市实验室，到乡村样板间，再到规模化复制"
            subtitle="由帝星咖啡完成城市端验证，再由乡村场景承接复制，最终走向县域规模化扩张。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 flex flex-col items-center">
            {copySteps.map((step, i) => {
              const isAccent = step.tone === 'accent';
              return (
                <div key={step.code} className="flex flex-col items-center">
                  <div
                    className={`px-8 py-4 rounded-lg text-center ${
                      isAccent
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-primary-500 text-background-50'
                    }`}
                  >
                    <div className="font-heading font-bold text-xl md:text-2xl whitespace-nowrap">
                      {step.code}
                    </div>
                    <div className="mt-1 text-sm">{step.title}</div>
                    <div className="mt-0.5 text-xs opacity-80">{step.desc}</div>
                  </div>
                  {i < copySteps.length - 1 && (
                    <div className="flex items-center my-3">
                      <div className="w-px h-8 bg-background-300"></div>
                      <i className="ri-arrow-down-line text-background-400"></i>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}